import { CardPaddingSizes } from './Card.types';

type CardConstsType = {
  paddingLeftRight: {
    [size in CardPaddingSizes]: number;
  };
  paddingTopBottom: {
    [size in CardPaddingSizes]: number;
  };
};

export const CardConsts: CardConstsType = {
  paddingLeftRight: {
    none: 0,
    medium: 24,
  },
  paddingTopBottom: {
    none: 0,
    medium: 16,
  },
};
